module.exports = __webpack_public_path__ + "static/media/SunLight.59055d8a.svg";